import React, { useEffect, useState, useRef } from 'react';
import Logo from '../../Assets/images/main-logo.svg';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import { ErrorMessage } from '@hookform/error-message';
import RegisterValidation from '../../Validation/SignupValidation';
import useMakeRequest from '../../utils/ApiHelper';
import { ApiConstants } from '../../constants/ApiConstants';
import { Link } from 'react-router-dom';
import { Modal } from 'react-bootstrap';
import { handleBackspaceAndEnter, saveToStorage } from '../../utils/Helper';
import { Config } from '../../config/Config';
import CommanPhoneNumber from '../layout/CommanPhoneNumber';
import SocialLogin from '../layout/SocialLogin';
import FrontLoader from '../layout/FrontLoader';
import AuthSubmitButton from '../layout/AuthSubmitButton';
import { LanguageConstants } from '../../constants/LanguageConstants';
import LanguageDropdown from '../layout/LanguageDropdown';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay, Pagination } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/pagination';

type AccountType = 'individual' | 'business';
const ACCOUNT_TYPE_DROPDOWN_ID = 'signupAccountTypeDropdown';

interface FormInputs {
  account_type: AccountType;
  first_name: string;
  last_name: string;
  company_name?: string;
  email: string;
  password: string;
  phone_number: string;
  confirm_password: string;
  agree: boolean;
  phone_country_code: string;
}

function Signup() {
  const numberOfDigits = 4;
  const regex = /^[0-9\b]+$/;
  const otpBoxRef = useRef<any>([]);
  const Register = useMakeRequest();
  const ResedOtp = useMakeRequest();
  const OTP = useMakeRequest();
  let countdown: any;
  const [otppopu, setOtpPopu] = useState(false);
  const [show, setShow] = useState(false);
  const [cshow, setCshow] = useState(false);
  const [otpData, setOtpData]: any = useState('');
  const [otpError, setOtpError] = useState('');
  const [otp, setOtp]: any = useState(new Array(numberOfDigits).fill(''));
  const [tempdata, setTempdata] = useState<any>({});
  const [timer, setTimer] = useState(120);
  const [isTimerRunning, setIsTimerRunning] = useState(false);
  const {
    register,
    watch,
    setValue,
    clearErrors,
    formState: { errors },
    handleSubmit,
  } = useForm<FormInputs>({
    mode: 'onChange',
    defaultValues: {
      account_type: 'individual',
      first_name: '',
      last_name: '',
      company_name: '',
      phone_country_code: '+1',
      phone_number: '',
    },
    resolver: yupResolver(RegisterValidation),
  });

  const accountType = watch('account_type');
  const boxImageSrc = `${process.env.PUBLIC_URL || ''}/signup/box image.png`;

  const onSubmit = (data: FormInputs) => {
    const base = {
      email: data.email.trim(),
      password: data.password,
      phone_country_code: data.phone_country_code,
      phone_number: (data.phone_number || '').trim(),
      account_type: data.account_type,
    };
    const payload =
      data.account_type === 'business'
        ? { ...base, company_name: (data.company_name || '').trim() }
        : {
            ...base,
            first_name: data.first_name.trim(),
            last_name: data.last_name.trim(),
          };
    setTempdata({ email: data.email });
    Register.makeRequest({ payload, url: ApiConstants?.Register, toastStatus: true });
  };

  useEffect(() => {
    if (Register?.status) {
      setOtpPopu(true);
      setTimer(120);
      setIsTimerRunning(false);
      setIsTimerRunning(true);
      setOtpError('');
      setOtp(new Array(numberOfDigits).fill(''));
      setOtpData('');
    }
    if (OTP?.status) {
      saveToStorage({ key: 'access_token', value: OTP?.data?.access_token });
      saveToStorage({ key: 'user_data', value: OTP?.data });
      window.location.href = `${Config?.BASE_URL}/category`;
    }
  }, [Register.status, OTP.status]);

  const onPaste = (event: any) => {
    const pasted = event.clipboardData.getData('text/plain');
    if (pasted.length === numberOfDigits && regex.test(pasted)) {
      setOtpError('');
      setOtpData(pasted);
      setOtp(pasted.split('').slice(0, numberOfDigits));
    }
  };
  const handleChange = (value: any, index: any) => {
    setOtpError('');
    if (value === '' || regex.test(value)) {
      const newArr = [...otp];
      newArr[index] = value;
      setOtp(newArr);
      setOtpData(newArr.join(''));
    }

    if (value && regex.test(value) && index < numberOfDigits - 1) {
      otpBoxRef.current[index + 1].focus();
    }
  };
  const handleKeyDown = (event: any) => {
    if (event.key === 'Enter') {
      event.preventDefault();
    }
  };
  const handleVerify = () => {
    if (otp.join('') === '' || otpData?.length < 4) {
      return setOtpError(LanguageConstants?.OTP_ENTER_ERROR);
    }
    setOtpError('');
    const payload = {
      email: tempdata?.email,
      otp: otpData,
      verify_type: 'MAIL_VERIFY',
    };
    OTP.makeRequest({ payload, url: ApiConstants?.VerifyOtp, toastStatus: true });
  };
  useEffect(() => {
    if (isTimerRunning && timer > 0) {
      countdown = setInterval(() => {
        setTimer((prevTimer) => prevTimer - 1);
      }, 1000);
    } else if (timer === 0) {
      clearInterval(countdown);
      setIsTimerRunning(false);
    }
    return () => {
      clearInterval(countdown);
    };
  }, [isTimerRunning, timer]);

  useEffect(() => {
    if (ResedOtp.status) {
      setIsTimerRunning(true);
      setTimer(120);
      setOtp(new Array(numberOfDigits).fill(''));
      setOtpData('');
      setOtpError('');
      window.setTimeout(() => otpBoxRef.current?.[0]?.focus?.(), 0);
    }
  }, [ResedOtp?.status]);

  const handelResendOtp = () => {
    setOtp(new Array(numberOfDigits).fill(''));
    setOtpData('');
    setOtpError('');
    const payload = {
      email: watch('email'),
      verify_type: 'MAIL_VERIFY',
    };
    ResedOtp.makeRequest({ payload, url: ApiConstants?.ResendOtp, toastStatus: true });
  };

  const handlePhoneNumber = (dialCode: string, nationalNumber: string) => {
    const d = String(dialCode ?? '').replace(/\D/g, '');
    setValue('phone_country_code', d ? `+${d}` : '');
    setValue('phone_number', nationalNumber ?? '');
  };

  const signupSubtitle =
    accountType === 'business'
      ? LanguageConstants?.SIGNUP_SUBTITLE_BUSINESS
      : LanguageConstants?.SIGNUP_SUBTITLE_INDIVIDUAL;

  const handleAccountTypeChange = (v: AccountType) => {
    setValue('account_type', v, { shouldValidate: true, shouldDirty: true });
    if (v === 'individual') {
      setValue('company_name', '');
      clearErrors('company_name');
    } else {
      setValue('first_name', '');
      setValue('last_name', '');
      clearErrors('first_name');
      clearErrors('last_name');
    }
  };

  const accountTypeLabel =
    accountType === 'business'
      ? LanguageConstants?.ACCOUNT_TYPE_BUSINESS
      : LanguageConstants?.ACCOUNT_TYPE_INDIVIDUAL;

  return (
    <>
      {ResedOtp?.loading || OTP?.loading ? <FrontLoader /> : null}
      <div className="auth-page auth-page--signup">
        <div className="auth-split">
          <aside className="auth-promo" aria-hidden="false">
            <div className="auth-promo-top">
              <a className="auth-promo-logo" href={`${Config?.BASE_URL}/`}>
                <img src={Logo} alt="Quote N Buy" />
              </a>
              <div className="w-100 auth-promo-txt-wrap">
                <div className="auth-promo-text-slider">
                  <Swiper
                    className="auth-promo-text-swiper"
                    modules={[Autoplay, Pagination]}
                    slidesPerView={1}
                    loop
                    speed={700}
                    autoplay={{
                      delay: 1500,
                      disableOnInteraction: false,
                      pauseOnMouseEnter: true,
                    }}
                    pagination={{ clickable: true }}
                  >
                    <SwiperSlide>
                      <div className="auth-promo-slide">
                        <h2 className="auth-promo-title">{LanguageConstants?.AUTH_PROMO_TITLE}</h2>
                        <p className="auth-promo-text">
                          {LanguageConstants?.WESPECIALIZETEXT ?? LanguageConstants?.AUTH_PROMO_TEXT}
                        </p>
                      </div>
                    </SwiperSlide>
                    <SwiperSlide>
                      <div className="auth-promo-slide">
                        <h2 className="auth-promo-title">
                          {LanguageConstants?.AUTH_PROMO_TITLE_2 ?? LanguageConstants?.AUTH_PROMO_TITLE}
                        </h2>
                        <p className="auth-promo-text">{LanguageConstants?.SIMPLYTEXT}</p>
                      </div>
                    </SwiperSlide>
                    <SwiperSlide>
                      <div className="auth-promo-slide">
                        <h2 className="auth-promo-title">
                          {LanguageConstants?.AUTH_PROMO_TITLE_3 ?? LanguageConstants?.AUTH_PROMO_TITLE}
                        </h2>
                        <p className="auth-promo-text">{LanguageConstants?.PERHAPSTEXT}</p>
                      </div>
                    </SwiperSlide>
                  </Swiper>
                </div>
              </div>
            </div>
            <img className="auth-promo-visual" src={boxImageSrc} alt="" />
          </aside>

          <div className="auth-form-wrap">
            <div className="auth-form-wrap-inner">
              <div className="auth-form-inner auth-form-inner-card">
              <h1 className="auth-title">{LanguageConstants?.SINGUP}</h1>
              <p className="auth-head-para">{signupSubtitle}</p>
              <form onSubmit={handleSubmit(onSubmit)}>
                <div className="com-input-wrap mb-3">
                  <label className="form-label" htmlFor="account_type">
                    {LanguageConstants?.ACCOUNT_TYPE}
                  </label>
                  <input type="hidden" id="account_type" {...register('account_type')} />
                  <div className="dropdown">
                    <button
                      type="button"
                      className="form-select text-start dropdown-toggle signup-account-type-toggle"
                      id={ACCOUNT_TYPE_DROPDOWN_ID}
                      data-bs-toggle="dropdown"
                      aria-expanded="false"
                    >
                      {accountTypeLabel}
                    </button>
                    <ul className="dropdown-menu w-100" aria-labelledby={ACCOUNT_TYPE_DROPDOWN_ID}>
                      <li>
                        <button
                          type="button"
                          className="dropdown-item"
                          onClick={() => handleAccountTypeChange('individual')}
                        >
                          {LanguageConstants?.ACCOUNT_TYPE_INDIVIDUAL}
                        </button>
                      </li>
                      <li>
                        <button
                          type="button"
                          className="dropdown-item"
                          onClick={() => handleAccountTypeChange('business')}
                        >
                          {LanguageConstants?.ACCOUNT_TYPE_BUSINESS}
                        </button>
                      </li>
                    </ul>
                  </div>
                  <ErrorMessage
                    errors={errors}
                    name="account_type"
                    render={({ message }) => <p className="input-error">{message}</p>}
                  />
                </div>

                {accountType === 'business' ? (
                  <div className="com-input-wrap mb-3">
                    <label className="form-label" htmlFor="company_name">
                      <span className="input-star">*</span>
                      {LanguageConstants?.COMPANY_NAME_LABEL}
                    </label>
                    <input
                      id="company_name"
                      className="form-control"
                      type="text"
                      placeholder={LanguageConstants?.COMPANY_NAME_PLACEHOLDER}
                      autoComplete="organization"
                      {...register('company_name')}
                    />
                    <ErrorMessage
                      errors={errors}
                      name="company_name"
                      render={({ message }) => <p className="input-error">{message}</p>}
                    />
                  </div>
                ) : null}

                {accountType === 'individual' ? (
                  <div className="row">
                    <div className="col-xl-6">
                      <div className="com-input-wrap mb-3">
                        <label className="form-label" htmlFor="first_name">
                          <span className="input-star">*</span>
                          {LanguageConstants?.FIRST_NAME}
                        </label>
                        <input
                          id="first_name"
                          className="form-control"
                          type="text"
                          placeholder={LanguageConstants?.FIRST_NAME}
                          autoComplete="given-name"
                          {...register('first_name')}
                        />
                        <ErrorMessage
                          errors={errors}
                          name="first_name"
                          render={({ message }) => <p className="input-error">{message}</p>}
                        />
                      </div>
                    </div>
                    <div className="col-xl-6">
                      <div className="com-input-wrap mb-3">
                        <label className="form-label" htmlFor="last_name">
                          <span className="input-star">*</span>
                          {LanguageConstants?.LAST_NAME}
                        </label>
                        <input
                          id="last_name"
                          className="form-control"
                          type="text"
                          placeholder={LanguageConstants?.LAST_NAME}
                          autoComplete="family-name"
                          {...register('last_name')}
                        />
                        <ErrorMessage
                          errors={errors}
                          name="last_name"
                          render={({ message }) => <p className="input-error">{message}</p>}
                        />
                      </div>
                    </div>
                  </div>
                ) : null}

                <div className="row">
                  <div className="col-xl-6">
                    <div className="com-input-wrap mb-3">
                      <label className="form-label" htmlFor="signup_email">
                        <span className="input-star">*</span>
                        {accountType === 'business'
                          ? LanguageConstants?.COMPANY_EMAIL
                          : LanguageConstants?.LOGIN_EMAIL_ADDRESS}
                      </label>
                      <input
                        id="signup_email"
                        className="form-control"
                        type="email"
                        placeholder={
                          accountType === 'business'
                            ? LanguageConstants?.COMPANY_EMAIL
                            : LanguageConstants?.LOGIN_EMAIL_ADDRESS_TEXT
                        }
                        autoComplete="email"
                        {...register('email')}
                      />
                      <ErrorMessage
                        errors={errors}
                        name="email"
                        render={({ message }) => <p className="input-error">{message}</p>}
                      />
                    </div>
                  </div>
                  <div className="col-xl-6">
                    <div className="com-input-wrap mb-3">
                      <label className="form-label" htmlFor="signup_phone_number">
                        {LanguageConstants?.PHONE_NUMBER}{' '}
                        <span className="optional-mark">{LanguageConstants?.OPTIONAL_MARK}</span>
                      </label>
                      <div className="wrap-phn-code signup-phone-field">
                        <CommanPhoneNumber
                          hideLabel
                          handleMobileNumber={handlePhoneNumber}
                          value={watch('phone_country_code')}
                          nationalNumber={watch('phone_number')}
                        />
                        <input
                          id="signup_phone_number"
                          className="wrap-phn-input"
                          type="text"
                          {...register('phone_number')}
                        />
                      </div>
                      <ErrorMessage
                        errors={errors}
                        name="phone_number"
                        render={({ message }) => <p className="input-error">{message}</p>}
                      />
                      <ErrorMessage
                        errors={errors}
                        name="phone_country_code"
                        render={({ message }) => <p className="input-error">{message}</p>}
                      />
                    </div>
                  </div>
                </div>


                <div className="row">
                  <div className="col-xl-6">
                    <div className="com-input-wrap mb-3">
                      <label className="form-label" htmlFor="signup_password">
                        <span className="input-star">*</span>{LanguageConstants?.PASSWORD}
                      </label>
                      <div className="position-relative">
                        <input
                          id="signup_password"
                          className="form-control pe-5"
                          type={cshow ? 'text' : 'password'}
                          placeholder={LanguageConstants?.PASSWORD}
                          autoComplete="new-password"
                          {...register('password')}
                        />
                        <i
                          className={cshow ? 'f-pass icon-eye-open' : 'f-pass icon-eye-slash-fill'}
                          onClick={() => setCshow(!cshow)}
                          role="presentation"
                        />
                      </div>
                      <ErrorMessage
                        errors={errors}
                        name="password"
                        render={({ message }) => <p className="input-error">{message}</p>}
                      />
                    </div>
                  </div>
                  <div className="col-xl-6">
                    <div className="com-input-wrap mb-3">
                      <label className="form-label" htmlFor="signup_confirm_password">
                        <span className="input-star">*</span>{LanguageConstants?.Confirm_Password}
                      </label>
                      <div className="position-relative">
                        <input
                          id="signup_confirm_password"
                          className="form-control pe-5"
                          type={show ? 'text' : 'password'}
                          placeholder={LanguageConstants?.Confirm_Password}
                          autoComplete="new-password"
                          {...register('confirm_password')}
                        />
                        <i
                          className={show ? 'f-pass icon-eye-open' : 'f-pass icon-eye-slash-fill'}
                          onClick={() => setShow(!show)}
                          role="presentation"
                        />
                      </div>
                      <ErrorMessage
                        errors={errors}
                        name="confirm_password"
                        render={({ message }) => <p className="input-error">{message}</p>}
                      />
                    </div>
                  </div>
                </div>

                <div className="form-label-area mb-3 mb-xl-4 d-block">
                  <div className="form-check">
                    <input className="form-check-input" type="checkbox" id="rememberMe" {...register('agree')} />
                    <label className="form-check-label" htmlFor="rememberMe">
                      {LanguageConstants?.IAGREEWITH}{' '}
                      <Link className="theme-color" to={'/cms/privacy-policy'}>
                        {LanguageConstants?.PRIVACY_POLICY}
                      </Link>{' '}
                      &amp;{' '}
                      <Link className="theme-color" to={'/cms/terms-and-conditions'}>
                        {LanguageConstants?.TERMS_SINGUP} &amp; {LanguageConstants?.Condition}
                      </Link>
                    </label>
                  </div>
                  <ErrorMessage
                    errors={errors}
                    name="agree"
                    render={({ message }) => (
                      <p className="input-error" role="alert">
                        {message}
                      </p>
                    )}
                  />
                </div>
                <AuthSubmitButton className="w-100 form-submit-btn" loading={Register?.loading}>
                  {LanguageConstants?.SINGUP}
                </AuthSubmitButton>
                <div className="small-txt text-center my-3">
                  {LanguageConstants?.GUEST_USER}{' '}
                  <Link to={'/'} className="theme-color">
                    {LanguageConstants?.GUEST}
                  </Link>
                </div>
                <div className="auth-or my-2" aria-hidden="true">
                  <span>{LanguageConstants?.OR_CONNECTOR}</span>
                </div>
                <SocialLogin signupGoogleAppleRow />
                <div className="small-txt text-center mt-3">
                  {LanguageConstants?.HAVE_ACCOUNT} ?
                  <Link to={'/login'} className="theme-color">
                    {LanguageConstants?.LOGIN}
                  </Link>
                </div>
              </form>
              </div>
            </div>
          </div>
        </div>

        <footer className="auth-footer">
          <div className="auth-footer__lang">
            <LanguageDropdown instanceId="langDropdownSignup" />
          </div>
          <div className="auth-footer__copy">{LanguageConstants?.COPYRIGHT}</div>
          <div className="auth-footer__legal">
            <Link to="/cms/privacy-policy">{LanguageConstants?.PRIACYPOLICY}</Link>
            <Link to="/cms/terms-and-conditions">{LanguageConstants?.TERMS}</Link>
          </div>
        </footer>
      </div>

      <Modal show={otppopu}>
        <div
          className="modal fade auth-modal text-center show"
          id="forgotPassModal"
          aria-labelledby="forgotPassModalLabel"
          aria-hidden="false"
          style={{ display: 'block' }}
        >
          <div className="modal-dialog modal-dialog-centered auth-otp-dialog">
            <div className="modal-content">
              <button
                type="button"
                onClick={() => setOtpPopu(false)}
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              >
                <i className="icon-close-square" />
              </button>
              <div className="modal-body">
                <h5 className="auth-modal-ttl mb-2">{LanguageConstants?.OTP_VERIFICATION}</h5>
                <p className="auth-modal-small-txt">
                  {LanguageConstants?.ENTER_OTP_DIGIT} ****{tempdata?.email?.split('@')[1]}
                </p>
                <div className="otp-inputs">
                  {otp.map((digit: any, index: any) => {
                    return (
                      <input
                        className="form-control"
                        key={index}
                        value={digit}
                        onPaste={onPaste}
                        maxLength={1}
                        ref={(ref) => (otpBoxRef.current[index] = ref)}
                        type="text"
                        placeholder="*"
                        onChange={(e) => handleChange(e.target.value, index)}
                        onKeyDown={handleKeyDown}
                        onKeyUp={(e) => handleBackspaceAndEnter(e, index, otpBoxRef, numberOfDigits)}
                      />
                    );
                  })}
                </div>
                <p style={{ color: 'red' }}>{otpError}</p>
                <p className="auth-modal-small-txt mb-2">{LanguageConstants?.DONT_RECIVE_CODE}?</p>
                {isTimerRunning ? (
                  <div className="auth-modal-small-txt border-0 fw-500 p-0 bg-transparent theme-color mb-4">
                    {LanguageConstants?.RESEND_IN} :{timer} s
                  </div>
                ) : (
                  <button
                    type="button"
                    className="auth-modal-small-txt border-0 fw-500 p-0 bg-transparent theme-color mb-4"
                    onClick={() => handelResendOtp()}
                  >
                    {LanguageConstants?.RESEND_OTP}
                  </button>
                )}
                <button
                  type="button"
                  onClick={handleVerify}
                  className="auth-modal-btn round-btn mt-4 w-50 d-block mx-auto"
                  data-bs-dismiss="modal"
                >
                  {LanguageConstants?.VERIFY}
                </button>
              </div>
            </div>
          </div>
        </div>
      </Modal>
    </>
  );
}

export default Signup;
